import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { name as MODULE_NAME } from '../../package.json';

const getModuleState = createModuleStateSelector(MODULE_NAME);

export default getModuleState;
